<template>
	<div class="picture-form">
		<h2>{{ $t('base.profile.change_picture') }}</h2>
		<spinner v-if="model.loading"/>
		<form v-if="!model.loading && model.hasData()" @submit.prevent="validateAndSubmit">
			<div class="form-group">
				<label>{{ $t('labels.general.picture') }}</label>
				<input type="file" name="file" id="file" @change="filesChange($event.target)" class="picture-file">
				<label for="file">
					<div v-if="pictureB64" class="picture-current">
						<avatar-picture :src="pictureB64" class="big rect"/>
						<div class="picture-remove" @click.stop.prevent="onPictureRemove">X</div>
					</div>
					<div v-else class="picture-empty">{{ $t('base.general.add_picture') }}</div>
				</label>
			</div>
			<error-box v-if="error" :error="error"/>
			<button-submit :loading="isLoading">{{ $t('buttons.actions.update_picture') }}</button-submit>
		</form>
		<!--pre>{{ model }}</pre>
		<pre>{{ pictureUid }}</pre>
		<pre>{{ pictureB64 }}</pre-->
	</div>
</template>

<script>
import generateBase64Picture from '@/utils/generateBase64Picture'
import AvatarPicture from '@/components/avatars/AvatarPicture'
import ApiObject from '@/classes/api/ApiObject'
import FormObject from '@/classes/api/FormObject'
export default {
	components: {
		AvatarPicture
	},
	props: [
		'user_uid'
	],
	data () {
		return {
			success: null,
			error: null,
			loading: false,
			downloading: false,
			uploading: false,
			pictureUid: '',
			pictureB64: '',
			model: new ApiObject(),
			form: new FormObject()
		}
	},
	computed: {
		isLoading () {
			return this.loading || this.downloading || this.uploading
		}
	},
	methods: {
		validateAndSubmit () {
			this.$validator.validateAll()
				.then(result => {
					if (result) this.updatePicture()
				})
		},
		getUser () {
			this.model.loading = true
			this.$api.users.getByUid(this, this.user_uid)
				.then(response => {
					this.$log.info('account information', 'users.getByUid OK', response)()
					this.model.data = response.body
					if (this.model.data.picture)
						this.downloadFile(this.model.data.picture)
				})
				.catch(error => {
					this.$log.error('account information', 'users.getByUid ERROR', error)()
					this.model.error = error
				})
				.finally(() => {
					this.model.loading = false
				})
		},
		filesChange (target) {
			Array.from(Array(target.files.length).keys())
				.map(i => {
					this.uploadFile(target.files[i])
				})
		},
		uploadFile (file) {
			this.uploading = true
			this.$api.files.upload(this, this.user_uid, this.watch_id, file)
				.then(response => {
					this.$log.info('user profile', 'files.upload OK', response)()
					this.downloadFile(response.body.uid)
				}).catch(error => {
					this.$log.error('user profile', 'files.upload ERROR', error)()
					this.error = error
				}).finally(() => {
					this.uploading = false
				})
		},
		downloadFile (file_uid) {
			this.downloading = true
			Promise.all([this.getPicture(file_uid), this.getPictureMetadata(file_uid)])
				.then(([picture, metadata]) => {
					this.$log.info('user profile', 'downloadFile() OK', picture, metadata)()
					this.pictureUid = metadata.uid
					this.pictureB64 = generateBase64Picture(picture, metadata.extension)
					this.model.data.picture = this.pictureUid
				}).catch(error => {
					this.$log.error('user profile', 'downloadFile() ERROR', error)()
				}).finally(() => {
					this.downloading = false
				})
		},
		getPicture (file_uid) {
			return this.$api.files.get(this, this.user_uid, this.watch_id, file_uid)
				.then(response => {
					this.$log.info('user profile', 'files.get OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error('user profile', 'files.get ERROR', error)()
					this.error = error
				})
		},
		getPictureMetadata (file_uid) {
			return this.$api.files.getMetadata(this, this.user_uid, this.watch_id, file_uid)
				.then(response => {
					this.$log.info('user profile', 'files.getMetadata OK', response)()
					return response.body
				}).catch(error => {
					this.$log.error('user profile', 'files.getMetadata ERROR', error)()
					this.error = error
				})
		},
		updatePicture () {
			this.loading = true
			const model = {
				fullname: this.model.data.fullname,
				picture: this.model.data.picture
			}
			this.$api.users.edit(this, this.user_uid, model)
				.then(response => {
					this.$log.info('user profile', 'users.edit OK', response)()
					this.$root.$emit('add-floating-box', { title: 'Success', text: 'User picture updated.' })
				}).catch(error => {
					this.$log.error('user profile', 'users.edit ERROR', error)()
					this.error = error
				}).finally(() => {
					this.loading = false
					this.$store.dispatch('getUser', { context: this })
				})
		},
		onPictureRemove () {
			this.pictureUid = ''
			this.pictureB64 = ''
			this.model.data.picture = ''
		}
	},
	mounted () {
		this.getUser()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/user/profile/accountinformation/PictureForm.vue